<!-- 
程式：ODAVF101.vue
功能：網頭首頁
作者：i9400540 施義濃
完成：2020-01-08
-->
<template>
  <div>
  </div>
</template>
<script>
export default {
  name: "ODAVF101",
  data() {
    return {};
  },
  mounted() {
    window.location = process.env.VUE_APP_LINK_WTHOME;
  }
};
</script>
<style>
</style>